import css from './ButtonGroup.module.scss';

export default function ButtonGroup({ options, selectedOption, setOption }) {
  return (
    <div className={css.wrapper}>
      {options.map((option) => {
        return (
          <button
            key={option.value}
            onClick={() => setOption(option.value)}
            className={`${css.button} ${option.value === selectedOption ? css.selected : ''}`}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
